import type { ComponentProps } from "react"

import { csrfToken } from "@/lib/http"

type Route = { url: string; method: "get" | "post" | "put" | "patch" | "delete" }

/**
 * A browser form submission instead of an Inertia visit. Use it when the server answers with
 * something Inertia cannot follow: a redirect to another site, or a file download.
 */
export function NativeForm({ route, children, ...props }: { route: Route } & Omit<ComponentProps<"form">, "action" | "method">) {
  const isGet = route.method === "get"

  return (
    <form action={route.url} method={isGet ? "get" : "post"} {...props}>
      {!isGet && <input type="hidden" name="authenticity_token" value={csrfToken()} />}
      {/* Browsers only submit GET and POST; Rails reads the real method from `_method`. */}
      {!isGet && route.method !== "post" && <input type="hidden" name="_method" value={route.method} />}
      {children}
    </form>
  )
}
